import React from 'react';
import { Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import autoBind from 'auto-bind';
import PropTypes from 'prop-types';
import { SemanticToastContainer } from 'react-semantic-toasts';
import FetchUserDetailForm from './FetchUserDetailForm';
import ResetPhoneForm from './ResetPhoneForm';

class ResetPhonePage extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  render() {
    const { userDetail } = this.props;
    return (
      <>
        <SemanticToastContainer />
        <h1>Reset Phone Number</h1>
        <br />
        <Grid columns={2} relaxed="very" stackable>
          <Grid.Column>
            <FetchUserDetailForm />
            {typeof userDetail.data.id !== 'undefined' && (
              <ResetPhoneForm data={userDetail} />
            )}
          </Grid.Column>
        </Grid>
      </>
    );
  }
}

const mapStateToProps = state => ({
  ...state.resetPhone,
});

ResetPhonePage.propTypes = {
  userDetail: PropTypes.shape({
    data: PropTypes.shape(),
  }).isRequired,
};

export default connect(mapStateToProps)(ResetPhonePage);
